import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Feature, IgoMap, Layer, PrintService } from '@igo2/geo';
import { WFS } from 'ol/format';
import Filter from 'ol/format/filter/Filter';
import { RechercheGdfService } from 'src/app/shared/services/recherche-gdf.service';
import * as olstyle from 'ol/style';
import { MapState } from '@igo2/integration';
import { EntityTableTemplate } from '@igo2/common/entity';
import { StorageService } from '@igo2/core/storage';
import { ActivityService } from '@igo2/core/activity';
import { MessageService } from '@igo2/core/message';
import { LanguageService } from '@igo2/core/language';

@Component({
    template: '',
    standalone: false
})
export abstract class SIGTRechercheGdfBaseComponent {
    abstract template: EntityTableTemplate;
    protected layer: any;
    protected messageApplication: { [key: string]: string } = {};
    protected wfsTool: WFS;
    protected style: olstyle.Style | ((feature, resolution) => olstyle.Style);
    #storageService = inject(StorageService);
    #mapState = inject(MapState);
    #printService = inject(PrintService);
    #activityService = inject(ActivityService);
    activityId: string;

    get map(): IgoMap {
        return this.#mapState.map;
    }

    constructor(
        protected rechercherGdfService: RechercheGdfService,
        protected httpClient: HttpClient,
        protected messageService: MessageService,
        protected languageService: LanguageService,
        protected cdRef: ChangeDetectorRef
    ) { }

    abstract formaterChampsFeaturePourResultatRecherche(features: Feature[]): Feature[];
    abstract buildFilter(): Filter;

    getLayer(layerName: string): void {
        this.rechercherGdfService.checkWMSLayers(layerName).subscribe({
            next: (layer: Layer) => {
                if (layer) {
                    this.layer = layer;
                    this.rechercherGdfService.hideAllGdfCreatedLayers(); // the wms layer is taking too long, no more adding or keeping it: layer.options.id
                } else {
                    console.log('Layer not found');
                }
            },
            error: (error) => {
                console.error('Error loading layer:', error);
            }
        });
    }
    rechercher():void {
        this.rechercherGdfService.hideAllGdfCreatedLayers();
        this.rechercherGdfService.rechercherFeatures(this.layer, this.buildFilter()).subscribe({
        next: features => {
            if (!features.length) {
            this.messageService.info(this.messageApplication.grilleVide);
            return;
            }

            this.rechercherGdfService.addSearchResultsToMap(
            this.layer.options.id,
            this.formaterChampsFeaturePourResultatRecherche(features),
            this.cdRef,
            this.template,
            this.style
            );
        },
        error: err => {
            this.messageService.error(this.messageApplication.erreurCouche);
            console.log(err);
        }
        });

    }

    validerNonEspaceSeul(ctrl: AbstractControl): ValidationErrors | null {
        if (ctrl.value?.length >= 1 && ctrl.value.trim() === '') {
            return {
                pattern: true
            };
        }
        return null;
    }

    protected supprimerZeroAuDebut(valeur: string): string {
        while (valeur.charAt(0) === '0') {
            valeur = valeur.substring(1);
        }
        return valeur;
    }

    getCleanKey(key: string) {
        return this.languageService.translate.instant(`sigt.integration.rechercheGdf.form.${key}`)
            .replace("'", "’")
            .replace(".", "");
    }
}
